import { useMutation } from '@tanstack/react-query';
import { Col, Form, InputProps, Modal, ModalProps, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  memo,
  useEffect,
  useState,
} from 'react';

import { IGetAllRoleParams } from 'apis/GraphQL/Variables/role';
import RoleApi from 'apis/RoleApis';
import { Button, InputForm, SelectForm } from 'components';
import { initLazySelectData } from 'components/Select/LazySelectForm';
import { IUserPermissionForm } from 'interfaces/User/User';
import { toastError } from 'utils/constants/functions';

type IProps = {
  data: any;
  // role: {
  //   data: ILazySelectData;
  //   mutate: UseMutateFunction<any, Error, IGetAllRoleParams, unknown>;
  // };
  onFinish: (values: any) => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
} & ModalProps;

type IFields = {
  label?: ReactNode;
  component?: ReactNode;
  inputProps: InputProps;
};

const ModalPermission = ({
  data,
  // role,
  setOpen,
  onFinish,
  ...props
}: IProps) => {
  const { open, title } = props;
  const [form] = useForm<IUserPermissionForm>();

  const [fields, setFields] = useState<IFields[]>([]),
    [roleData, setRoleData] = useState(initLazySelectData);

  const { isPending: isGetAllRoleMutatePending, mutate: getAllRoleMutate } =
    useMutation({
      mutationFn: (params: IGetAllRoleParams) =>
        RoleApi.getAllRoleByFilter(params),
      onSuccess: (res: any) => {
        if (res?.data?.getRole) {
          setRoleData({
            options: (res.data.getRole?.items ?? []).map(
              (item: any) =>
                ({
                  label: item?.name,
                  value: item?.id,
                }) as DefaultOptionType,
            ),
            totalItems: res.data.getRole?.pageInfo?.totalItems ?? 0,
          });
          return;
        }

        if ((res?.errors ?? []).length > 0)
          toastError(
            `Lỗi khi lấy danh sách chức vụ. ${res?.errors?.[0]?.message}`,
          );
      },
      onError: (error) => {
        console.log(error);
      },
    });

  useEffect(() => {
    if (!open) return;

    getAllRoleMutate({});
  }, [open]);

  // const handleRoleSelectScrollChange = (params: ILazySelectParams) => {
  //   const { pageSize, value } = params;

  //   getAllRoleMutate({ pageSize, searchValue: value });
  // };

  useEffect(() => {
    const fields: IFields[] = [
      {
        inputProps: {
          disabled: true,
          name: 'id',
        },
        label: 'Mã chức vụ',
      },
      {
        inputProps: {
          name: 'jobName',
          disabled: true,
        },
        label: 'Tên chức vụ',
      },
      {
        inputProps: {
          name: 'roleId',
        },
        label: 'Quyền',
        component: (
          <SelectForm
            size="middle"
            options={roleData?.options}
            placeholder="Chọn quyền"
            loading={isGetAllRoleMutatePending}
            className="max-w-[330px] h-[40px] text-start"
          />
          // <LazySelectForm
          //   size="middle"
          //   data={roleData}
          //   placeholder="Chọn quyền"
          //   loading={isGetAllRoleMutatePending}
          //   className="max-w-[330px] h-[40px] text-start"
          //   onSelectScrollChange={handleRoleSelectScrollChange}
          // />
        ),
      },
    ];

    setFields(fields);
  }, [open, roleData]);

  useEffect(() => {
    if (!open) return;

    if (!Object.keys(data)?.length) return;
    const fieldsValue: any = {
      id: data?.id,
      jobName: data?.jobName,
      roleId: roleData?.options?.find(
        (option) => option?.value === data?.roleId,
      )?.value,
    };

    form.setFieldsValue(fieldsValue);
  }, [open, data, roleData]);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleClickSave = () => {
    const fields = form.getFieldsValue();
    onFinish(fields);
    form.resetFields();
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={handleCancel}
      classNames={{
        content: '!p-0',
        header:
          '!px-[24px] !pt-[20px] !pb-[8px] !border-sub !border-solid !border-b-[1px]',
        body: '!px-[42px]',
        footer: '!px-[24px] !py-[20px] !bg-rowTable !rounded-b-[8px]',
      }}
      footer={() => (
        <Row gutter={[8, 16]} justify={'end'} align={'middle'}>
          <Col>
            <Button
              fill
              title={'Huỷ'}
              customClass="!bg-rowTable !border-transparent !text-neutral-30"
              handleOnclick={handleCancel}
            />
          </Col>
          <Col>
            <Button
              fill
              title={'Lưu'}
              customClass="w-[131px]"
              handleOnclick={handleClickSave}
            />
          </Col>
        </Row>
      )}
    >
      <Form form={form}>
        {fields.map((field, index) => {
          const { name } = field.inputProps;

          return (
            <Form.Item
              key={index}
              name={name}
              label={field.label}
              className="text-end"
            >
              {field.component ? (
                field.component
              ) : (
                <InputForm
                  size="middle"
                  className="w-[330px] h-[40px]"
                  {...field.inputProps}
                />
              )}
            </Form.Item>
          );
        })}
      </Form>
    </Modal>
  );
};

export default memo(ModalPermission);
